<template>
<div class="fixed-top" id="header" >
  <b-navbar toggleable="lg" variant="" type=""  >
    <b-navbar-brand>
      <table>
        <tbody>
          <tr>
              <td rowspan="5" style="width:100px">  <b-img src="../assets/apdcl_logo.png" fluid  style="height:75px;width:75px" alt="Responsive image"></b-img></td>

          </tr>
            <tr>
              <td id="title-a" class="title-a text-blue ">অসম শক্তি বিতৰণ কোম্পানী লিমিটেড</td>
                <!-- <td  class="text-blue right" style="text-align: right;width: 45vw;">Welcome <data id="consName"></data></td> -->
            </tr>
            <tr>
              <td id="title-e" class="title-e text-blue">ASSAM POWER DISTRIBUTION COMPANY LIMITED</td>
              <td style="text-align: right;width: 45vw;">
                <router-link to="#">
                  <b-button @click="$bvModal.show('logoutModal')" variant="outline-danger" size="sm">Log Out</b-button>
                </router-link>
              </td>
            </tr>
        </tbody>
      </table>
    </b-navbar-brand>
</b-navbar>
<span id="tagline-a" hidden ></span>
<span id="tagline-e" hidden></span>
<span id="language" hidden ></span>
<span id="support" hidden></span>

<b-modal id="logoutModal" centered  scrollable title="Confirm Log Out" hide-footer>
    <p class="success">
      Are you sure you want to Log Out?<br><br>
      <b-button id="" @click="logout()"  size="sm" variant="outline-success"  style="width:100px">Yes</b-button>&nbsp&nbsp&nbsp&nbsp
      <b-button id="" @click="closeModal('logoutModal')" size="sm" variant="outline-primary" style="width:100px">No </b-button>
    </p>
</b-modal>

</div>

</template>
<script type="text/javascript">
  import axios from 'axios'
export default {
    methods:
    {
     logout()
       {
        var  accessToken = sessionStorage.getItem("accessToken");
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlMyBijulee+'/auth/logout',
        headers: { 
          'Authorization': accessToken, 
          'Content-Type': 'application/json'
        },
      
      };
      
      this.show=true;
      var parent = this;
      axios.request(config)
      .then((response) => {
        parent.show= false;
       if(response.data.status=="success")
       {
        sessionStorage.removeItem("accessToken");
        sessionStorage.removeItem("consList");
        sessionStorage.removeItem("selectedCons");
         window.location.href="/website"
       }
       else{
        parent.$bvToast.toast('Error in Log Out !', {
        title: `Alert`,
        variant: 'danger',
        solid: true
      })
       }
      })
    },
        closeModal(id)
        {
          this.$bvModal.hide(id)
        }
    }
  }
</script>
<style lang="scss" scoped="true" >

body
{
  overflow-x: hidden;
}
#header
{
  transition: 0.6s;
  background-color: #ffff;
  box-shadow: 0 4px 7px 1px #e0e0e0;
}

.title-a
{
  font-size: 1.3rem;
  font-weight: 900;
  margin-top: 0px;
  letter-spacing: 0.5px;

}
.title-e
{
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.5px;

}
@font-face {
  font-family: Assamese_Font;
  src: url("../assets/Assamese_font/KirtanUni.ttf");
}
div{
    font-family: arial, Assamese_Font;
}
</style>
